import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/helpers";
interface BadgeProps {
  children: React.ReactNode;
  className?: string;
}
export const Badge = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("px-3 py-1 rounded-full glass-purple border-none body-small font-semibold whitespace-nowrap before:hidden after:hidden card-text-primary", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <span className={t1}>{children}</span>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};